<form [formGroup]="paymentFormGroup" class="mt-3 offer-detail__form offer-detail__form--payment">
  @if (currentProductAlreadyOrdered()) {
    <app-general-warning
      *appApplyIfNotEmpty="translationService.getTranslation('currentProduct.alreadyOrdered')"
      [warnings]="[{infoText: translationService.getTranslation('currentProduct.alreadyOrdered')}]">
    </app-general-warning>
  }
  <ng-container formArrayName="extendedData" class="offer-detail__payment-extended-data">
    @for (field of getAdditionalDataControls(); track field; let i = $index) {
      <div class="offer-detail__payment-extended-data-item">
        <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--extended-data">
          <mat-label>{{ additionalData[i].description }}</mat-label>
          <input matInput [formControlName]="i" [value]="field.value">
          @if (field.hasError('message')) {
            <mat-error class="offer-detail__error">{{ field.getError('message') }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    }
  </ng-container>

  <!-- Die Preisermittlung laeuft gegen das Backend - solange zeigen wir einen Spinner. Er steht
       oben ueber den Zahlarten, wie in den uebrigen Views, und nicht unten ueber dem Button.
       Bewusst die kleine Variante (40px): Der Block erscheint und verschwindet waehrend der
       Preisermittlung, die grosse liess die Zahlarten darunter sichtbar springen. -->
  @if (calculatingPrice) {
    <div class="offer-detail__price-spinner" data-cy="payment-price-spinner">
      <app-loading-spinner [type]="'small'"></app-loading-spinner>
    </div>
  }

  <!-- Darstellung der Zahlarten -->
  @if (formsOfPayment.length > 1) {
    <div class="col-12 pb-2 offer-detail__payment-method-label"
         [innerHTML]="translationService.getTranslation('choseFormOfPayment')"></div>
    <div class="row offer-detail__row offer-detail__row--payment-methods">
      @for (formOfPayment of formsOfPayment; track formOfPayment) {
        <div [className]="'mb-3 col-12 col-sm-6' + ' ' +
                      'col-' + (CssPropertiesEnum.formOfPaymentFxFlex|cssProperty: vHostService) + ' ' +
                      'col-sm-' + (CssPropertiesEnum.formOfPaymentFxFlexSM|cssProperty: vHostService) + ' ' +
                      'col-md-' + (CssPropertiesEnum.formOfPaymentFxFlexMD|cssProperty: vHostService) + ' ' +
                      'col-lg-' + (CssPropertiesEnum.formOfPaymentFxFlexLG|cssProperty: vHostService) + ' ' +
                      'col-xl-' + (CssPropertiesEnum.formOfPaymentFxFlexXL|cssProperty: vHostService) + ' ' +
                      'col-xxl-' + (CssPropertiesEnum.formOfPaymentFxFlexXXL|cssProperty: vHostService) + ' offer-detail__payment-method-item'">
          <div data-bs-toggle="collapse" tabindex="0" (keydown.space)="onSelectFormOfPayment(formOfPayment)"
               (keydown.enter)="onSelectFormOfPayment(formOfPayment)"
               (click)="onSelectFormOfPayment(formOfPayment)" data-cy="choose-form-of-payment"
               class="offer-detail__payment-method-select">
            <label class="card-radio-label w-100 offer-detail__payment-method-label">
              <input type="radio" name="pay-method" id="pay-methodoption1"
                     class="card-radio-input offer-detail__payment-method-radio"
                     [checked]="formOfPayment === selectedFormOfPayment">
              <span class="card-radio py-3 text-center text-truncate offer-detail__payment-method-description">
                @if (!!formOfPayment.image) {
                  <img class="image custom-icon d-block offer-detail__payment-method-img"
                       [ngSrc]="formOfPayment.image.src"
                       [width]="500"
                       [height]="24"
                       [alt]="formOfPayment?.image?.altText">
                } @else {
                  {{ formOfPayment.description }}
                }
              </span>
            </label>
          </div>
        </div>
      }
      @if (paymentFormGroup.get('formOfPayment').hasError('required')) {
        <mat-error class="offer-detail__error"
                   [innerHTML]="translationService.getTranslation('error_required_field')"></mat-error>
      }
    </div>
  }

  <!--Zahlungsrhythmus für das Abonnement-->
  <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--payment-frequency">
    <mat-label [innerHTML]="translationService.getTranslation('payment_rhythm')"></mat-label>
    <mat-select formControlName="paymentFrequency" required
                [value]="paymentFormGroup.get('paymentFrequency').value" data-cy="select-payment-frequency">
      @for (paymentFrequency of paymentFrequencies; track paymentFrequency) {
        @if (paymentFrequency.useInFE) {
          <mat-option
            data-cy="option-payment-frequency"
            [value]="paymentFrequency">{{ paymentFrequency.description }}
          </mat-option>
        }
      }
    </mat-select>
    @if (paymentFormGroup.get('paymentFrequency').hasError('message')) {
      <mat-error class="offer-detail__error"
      >{{ paymentFormGroup.get('paymentFrequency').getError('message') }}
      </mat-error>
    }
  </mat-form-field>

  <!-- Bankverbindung -->
  @if (needIbanBic) {
    <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--iban">
      <mat-label [innerHTML]="translationService.getTranslation('payment_iban')"></mat-label>
      <input maxLength="34" matInput formControlName="iban" [value]="paymentFormGroup.get('iban').value"
             oninput="this.value = this.value.toUpperCase()" (keyup)="transferIban()" #iban
             data-cy="input-iban">
      @if (iban === document?.activeElement && iban.value.length >= 1) {
        <mat-hint align="end">{{ iban.value.length }} / {{ iban.maxLength }}</mat-hint>
      }
      @if (paymentFormGroup.get('iban').hasError('message')) {
        <mat-error class="offer-detail__error"
        >{{ paymentFormGroup.get('iban').getError('message') }}
        </mat-error>
      }
    </mat-form-field>
    @if (paymentFormGroup.get('iban').status === 'PENDING') {
      <div class="offer-detail__iban-spinner">
        <app-loading-spinner [type]="'small'"></app-loading-spinner>
      </div>
    }
    <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--bic">
      <mat-label [innerHTML]="translationService.getTranslation('payment_bic')"></mat-label>
      <input matInput formControlName="bic" [value]="paymentFormGroup.get('bic').value" data-cy="input-bic">
      @if (paymentFormGroup.get('bic').hasError('message')) {
        <mat-error class="offer-detail__error"
        >{{ paymentFormGroup.get('bic').getError('message') }}
        </mat-error>
      }
    </mat-form-field>
  }

  <!-- Wer bezahlt das Abo? Name, Vorname des Zahlers -->
  @if (askForPaymentAccountHolder) {
    <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--account-holder">
      <mat-label [innerHTML]="translationService.getTranslation('payment_holder')"></mat-label>
      <input matInput minlength="1" maxlength="255" formControlName="accountHolder"
             [value]="paymentFormGroup.get('accountHolder').value" data-cy="input-bic" #accountHolder>
      @if (accountHolder === document?.activeElement && accountHolder.value.length >= 1) {
        <mat-hint align="end">{{ accountHolder.value.length }} / {{ accountHolder.maxLength }}</mat-hint>
      }
      @if (paymentFormGroup.get('accountHolder').hasError('message')) {
        <mat-error>{{ paymentFormGroup.get('accountHolder').getError('message') }}</mat-error>
      }
    </mat-form-field>
  }

  <!-- Wird auch eine Rechnungs-E-Mail benötigt? -->
  @if (needInvoiceMailAddress()) {
    <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--invoice-email">
      <mat-label [innerHTML]="translationService.getTranslation('payment_invoice_email')"></mat-label>
      <input maxLength="50" matInput formControlName="invoiceEmail"
             [value]="paymentFormGroup.get('invoiceEmail').value" #email>
      @if (email === document?.activeElement && email.value.length >= 1) {
        <mat-hint align="end">{{ email.value.length }} / {{ email.maxLength }}</mat-hint>
      }
      @if (!paymentFormGroup.get('invoiceEmail').valid) {
        <mat-error class="offer-detail__error">
          {{
            paymentFormGroup.get('invoiceEmail').hasError('required')
              ? translationService.getTranslation('error_email_empty')
              : translationService.getTranslation('error_email_invalid')
          }}
        </mat-error>
      }
    </mat-form-field>
  }

  <!-- Auswahl des Startdatums -->
  <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--startdate"
                  (click)="picker1.open()">
    <mat-label [innerHTML]="translationService.getTranslation('startdate')"></mat-label>
    <input matInput [min]="minDate()" [max]="maxDate()" [matDatepicker]="picker1" readonly
           formControlName="startdate">
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>

  <!-- Auswahl der Ausgabe -->
  @if (isDigitalOffer() && askForEditionId()) {
    <mat-form-field class="col-12 offer-detail__form-field offer-detail__form-field--edition">
      <mat-label [innerHTML]="translationService.getTranslation('order_edition')"></mat-label>
      <mat-select formControlName="editionId" required>
        @for (variantCode of offer()?.product?.variantCodeList; track variantCode) {
          <mat-option [value]="variantCode">{{ variantCodeDescriptions.get(variantCode) }}
          </mat-option>
        }
      </mat-select>
      @if (paymentFormGroup.get('editionId').hasError('message')) {
        <mat-error class="offer-detail__error"
        >{{ paymentFormGroup.get('editionId').getError('message') }}
        </mat-error>
      }
    </mat-form-field>
  }

  <!-- SEPA-Lastschriftmandat -->
  @if (needIbanBic && showSEPABox()) {
    <div class="col-12 offer-detail__sepa-checkbox-container">
      <mat-checkbox formControlName="sepaOptIn" required aria-required="true"
                    class="text-wrap offer-detail__sepa-checkbox" #sepaBox>
        <div [innerHTML]="translationService.getTranslation('order_sepaaccept')"></div>
      </mat-checkbox>
      @if (!sepaBox.checked && checkBoxes()) {
        <mat-error class="small errorOffset offer-detail__error"
                   [innerHTML]="translationService.getTranslation('order_sepaaccept_error')"></mat-error>
      }
    </div>
  }

  <!-- Wurde Paypal gewählt, verbinden wir uns damit -->
  @if (isOnlinePayment() && !onlinePaymentSuccess()) {
    <app-onlinepayment
      [subscriptionStartTime]="selectedStartDate()"
      (onlinePaymentSuccess)="setOnlinePaymentSuccess($event)">
    </app-onlinepayment>
  }

  <!--Navigationselemente-->
  <div class="text-end mt-1 offer-detail__next-btn offer-detail__next-btn--payment">
    <button type="button" class="me-3 offer-detail__back-btn offer-detail__back-btn--payment"
            mat-raised-button
            (click)="parentStepper.previous()"
            [innerHTML]="translationService.getTranslation('button_back')">
    </button>

    <button mat-raised-button
            color="primary" type="submit"
            (click)="onNextClick()"
            data-cy="btn-payment-next"
            [innerHTML]="isOnlinePayment() ? translationService.getTranslation('button_next') : translationService.getTranslation('button_check_price') "
            [disabled]="calculatingPrice || !paymentStepReady()">
    </button>
  </div>

</form>
